import { ref } from 'vue'

/**
 * 2026-09-14 — "모든 상황이 인앱브라우저처럼" 지시. 어느 컴포넌트에서든 외부 URL을 열 때
 * 새 탭/네비게이션 대신 이걸 호출하면 App.vue에 한 번만 마운트된 InAppBrowserSheet가 뜬다.
 * useChat/useRecording과 같은 모듈 레벨 싱글턴 패턴 — prop 없이 어디서든 open()/close() 호출.
 */
const activeUrl = ref<string | null>(null)
const activeTitle = ref<string>('')

export function useInAppBrowser() {
  function open(url: string, title = '') {
    if (!url) return
    activeUrl.value = url
    activeTitle.value = title
  }
  function close() {
    activeUrl.value = null
    activeTitle.value = ''
  }
  return { activeUrl, activeTitle, open, close }
}
